import Axios, { AxiosError } from 'axios';

import { AuthenticationService } from 'api/authentication/services';

export const InterceptedAxios = Axios.create();

InterceptedAxios.interceptors.request.use((config) => {
  // const state = store.getState();

  return {
    ...config,
    // headers: {
    //   'x-unfi-host-system': hostSystem,
    //   'x-unfi-language': language,
    //   'x-unfi-sub-env': Environment.getSubEnvironment(),
    //   ...config.headers,
    // },
    // params: {
    //   hostSystem,
    //   ...config.params,
    // },
  };
});

InterceptedAxios.interceptors.response.use(
  (response) => {
    if (response.status === 401) {
      AuthenticationService.logout();
    }
    return response;
  },
  (error: AxiosError) => {
    if (error && error.response && error.response.status === 401) {
      AuthenticationService.logout();
    }
    return Promise.reject(error);
  }
);
